import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type BadgeProps = React.ComponentProps<'div'> & {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'outline' | 'neutral';
};

export default function Badge({
  children,
  className,
  variant = 'default',
  ...props
}: BadgeProps) {
  const commonStyles = cn(
    'flex items-center justify-center gap-2 px-2 py-1 rounded-full ',
    'font-satoshi text-[12px] font-medium',
    'bg-[#F9FAFB] border border-[#E5E7EB] text-[#6C737F]',
    'dark:bg-[#1F2A37] dark:border-[#384250] dark:text-white'
  );

  const variantStyles = {
    default:
      'bg-[#E0D0FF] border border-[#7846FF] text-[#7846FF] dark:bg-[#7846FF] dark:border-[#7846FF] dark:text-white',
    outline: 'bg-transparent border border-[#E5E7EB] text-[#6C737F]',
    neutral: 'bg-[#F9FAFB] border border-[#E5E7EB] text-[#6C737F]',
  };

  return (
    <div
      className={cn(commonStyles, variantStyles[variant], className)}
      {...props}
    >
      {children}
    </div>
  );
}
